// DS1.7.3
import React from 'react';
import classnames from 'classnames';
import BoostFilledIcon from '../../Icons/16x16/BoostFilled';
import { IconSize } from '../../Icons/IconWrap';

import s from './BoostedIndicator.scss';

interface Props {
  className?: string;
}

const BoostedIndicator: React.FC<Props> = ({ className }) => {
  return (
    <div className={classnames(s['root'], className)}>
      <BoostFilledIcon disableDefaultColors size={IconSize.SMALLER} />
    </div>
  );
};
BoostedIndicator.displayName = 'BoostedIndicator';

export default BoostedIndicator;
